import { call, put, takeLatest } from 'redux-saga/effects';
import { InsuranceClaimApi } from '@apis/InsuranceClaimApi';
import { requestDocuments, requestDocumentsSuccess, requestDocumentsReset, RequestDocumentsPayload } from './action';
import { SagaPayload } from '@utils/typescript';
import { toastShow } from '@components/ToastProvider';
import i18n from '@components/i18n';

function* handleRequestDocuments({ payload }: SagaPayload<RequestDocumentsPayload>) {
  const { claimableType, claimableId, documentTypes, note } = payload;
  try {
    yield call(InsuranceClaimApi.requestDocuments, {
      claimableType,
      claimableId,
      documentTypes,
      note,
    });
    yield put(requestDocumentsSuccess());
    yield put(toastShow({ status: 'success', body: i18n.t('toast.requestDocuments.success') }));
  } catch (e) {
    yield put(requestDocumentsReset());
    yield put(toastShow({ status: 'danger', body: i18n.t('toast.requestDocuments.error') }));
  }
}

export default function* () {
  yield takeLatest(requestDocuments, handleRequestDocuments);
}
